import { render, staticRenderFns } from "./Google.vue?vue&type=template&id=41c5d5d4&scoped=true"
import script from "./Google.vue?vue&type=script&lang=js"
export * from "./Google.vue?vue&type=script&lang=js"
import style0 from "./Google.vue?vue&type=style&index=0&id=41c5d5d4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c5d5d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41c5d5d4')) {
      api.createRecord('41c5d5d4', component.options)
    } else {
      api.reload('41c5d5d4', component.options)
    }
    module.hot.accept("./Google.vue?vue&type=template&id=41c5d5d4&scoped=true", function () {
      api.rerender('41c5d5d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/social/Google.vue"
export default component.exports